/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 同意者
 */
export type TreatmentAgreedByEnum =
  (typeof TreatmentAgreedByEnum)[keyof typeof TreatmentAgreedByEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentAgreedByEnum = {
  FAMILY: 'FAMILY',
  RELATED: 'RELATED',
  NONE: 'NONE',
} as const;
